import { useLocation, useParams } from 'react-router-dom';
import { ApplicantPage } from './ApplicantPage';

/**
 * This is a wrapper component that is used to wrap the ApplicantPage component.
 * This is required so that the 3 column page doesn't do a full reload when the route changes - 
 * so we can switch between /payments/ and /a/ without losing a call or doing a full refresh of the history and notes tabs.
 */
export function ApplicantRouteWrapper() {
  const { uid, subsurvey, applicantDash } = useParams() as Record<string, string>;
  const { pathname } = useLocation();
  
  // Determine if this is a payments route
  const isPaymentsRoute = pathname.startsWith('/payments/');
  
  return (
    <ApplicantPage 
      uid={uid}
      subsurvey={isPaymentsRoute ? 'payments' : subsurvey}
      applicantDash={applicantDash}
    />
  );
}
